import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../context/AppContext';
import { PostCallWithErrorResponse } from '../../api/ApiServices';
import ApiConfig from '../../api/ApiConfig';
import { LineItem } from './AccountReportShared';

const ProfitAndLossPage = () => {
  const { sidebar } = useContext(AppContext);
  const [report, setReport] = useState({});

  const getPlReport = () => {
    PostCallWithErrorResponse(ApiConfig.GET_PROFIT_AND_LOST_STATEMENT, JSON.stringify({})).then((res) => {
      if (res?.json?.Success) setReport(res?.json?.Data);
    });
  };

  useEffect(() => {
    getPlReport();
  }, []);

  return (
    <main className={sidebar ? "taskMain" : "cx-active taskMain"} id="cx-main">
      <div id="sales-main">
        <section className="cx-inneer-header">
          <div className="main-inner">
            <div className="left">
              <label>Profit &amp; Loss</label>
            </div>
          </div>
        </section>

        <section className="mt-3">
          <div className="bg-light p-4">
            <div className="row g-3 mb-4">
              {/* Revenue Card */}
              <div className="col-md-4">
                <div className="card h-100 p-3 border-0" style={{ backgroundColor: '#e6fffa', border: '1px solid #b2f5ea' }}>
                  <div className="text-muted fw-bold text-uppercase" style={{ fontSize: '0.75rem' }}>Total Revenue</div>
                  <div className="fw-bold text-success mt-1 fs-4">{report?.TotalRevenue}</div>
                  <div className="text-success mt-2 d-inline-block px-2 py-1 rounded" style={{ fontSize: '0.75rem', backgroundColor: 'rgba(25,135,84,0.1)' }}>+12% vs last year</div>
                </div>
              </div>

              {/* Expenses Card */}
              <div className="col-md-4">
                <div className="card h-100 p-3 border-0" style={{ backgroundColor: '#fff5f5', border: '1px solid #feb2b2' }}>
                  <div className="text-muted fw-bold text-uppercase" style={{ fontSize: '0.75rem' }}>Total Expenses</div>
                  <div className="fw-bold text-danger mt-1 fs-4">{report?.TotalExpenses}</div>
                  <div className="text-danger mt-2 d-inline-block px-2 py-1 rounded" style={{ fontSize: '0.75rem', backgroundColor: 'rgba(220,53,69,0.1)' }}>+5% vs last year</div>
                </div>
              </div>

              {/* Net Income Card */}
              <div className="col-md-4">
                <div className="card h-100 p-3 border-0" style={{ backgroundColor: '#ebf8ff', border: '1px solid #bee3f8' }}>
                  <div className="text-muted fw-bold text-uppercase" style={{ fontSize: '0.75rem' }}>Net Income</div>
                  <div className="fw-bold text-primary mt-1 fs-4">{report?.NetIncome}</div>
                  <div className="text-primary mt-2 d-inline-block px-2 py-1 rounded" style={{ fontSize: '0.75rem', backgroundColor: 'rgba(13,110,253,0.1)' }}>
                    Margin: {((report?.NetIncome / report?.TotalRevenue) * 100).toFixed(1)}%
                  </div>
                </div>
              </div>
            </div>

            {/* Main Statement Card */}
            <div className="card border-0" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-end mb-4 border-bottom pb-3">
                  <h4 className="mb-1">Statement of Activities</h4>
                </div>
                <div className="row g-5">
                  <div className="col-md-6">
                    <h5 className="fw-bold mb-3">Revenues</h5>
                    {report?.RevenueGroups?.map((category, idx) => (
                      <div key={idx} className="mb-4">
                        <h6 className="text-muted fw-bold text-uppercase ps-2 border-start border-3 border-success mb-2" style={{ fontSize: '0.75rem' }}>{category?.GroupName}</h6>
                        {category?.LineItems?.map((item, i) => <LineItem key={i} name={item.LedgerName} value={item.Amount} />)}
                      </div>
                    ))}
                  </div>
                  <div className="col-md-6">
                    <h5 className="fw-bold mb-3">Expenses</h5>
                    {report?.ExpenseGroups?.map((category, idx) => (
                      <div key={idx} className="mb-4">
                        <h6 className="text-muted fw-bold text-uppercase ps-2 border-start border-3 border-danger mb-2" style={{ fontSize: '0.75rem' }}>{category?.GroupName}</h6>
                        {category?.LineItems?.map((item, i) => <LineItem key={i} name={item.LedgerName} value={item.Amount} />)}
                      </div>
                    ))}
                  </div>
                </div>

                <div
                  className="mt-4 p-4 rounded-3 d-flex justify-content-between align-items-center"
                  style={{ backgroundColor: report?.NetIncome >= 0 ? '#f0fff4' : '#fff5f5' }}
                >
                  <span className="fw-bold text-dark fs-6">Net Surplus / (Deficit)</span>
                  <span className={`fw-bold fs-5 ${report?.NetIncome >= 0 ? 'text-success' : 'text-danger'}`}>
                    {report?.NetIncome}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default ProfitAndLossPage;
